export default __webpack_public_path__ + "static/media/missing_vowels_intro.5ea1a78f.mp3";